import React from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGear } from "@fortawesome/free-solid-svg-icons";
import { Button, Card, Row, Col } from "react-bootstrap";

const MyEventsSummary = ({ events }) => {
  const navigate = useNavigate();

  if (!events || events.length === 0) return null;

  return (
    <Card className="shadow-sm border-0 mt-3">
      <Card.Body>
        <Card.Title className="mb-2 d-flex justify-content-between align-items-center">
          <h5 className="fw-bold">My Events</h5>
          <Button
            size="sm"
            variant="outline-secondary"
            onClick={() => navigate("/admin/events")}
          >
            <FontAwesomeIcon icon={faGear} className="" />
            
          </Button>
        </Card.Title>

        <Row className="mb-2">
          <Col xs={6} className="fw-semibold text-muted">
            Total Events:
          </Col>
          <Col>{events.length}</Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default MyEventsSummary;
